<script setup>
import ModalWrapper from '@/modals/ModalWrapper';
import { ref } from 'vue';
import { useRequestStore } from '@/stores/request';
import { useOptionsStore } from '@/stores/options';
import { storeToRefs } from 'pinia';

const emit = defineEmits(['close-modal', 'cancel-modal']);

const { tireSetOptions } = storeToRefs(useOptionsStore());
const { storeRequest } = useRequestStore();

const form = ref({
    tire_set_hash: null,
    type: 'from_storage',
    scheduled_for: new Date().toISOString().slice(0, 10),
    scheduled_time: null,
});

const save = async () => {
    try {
        await storeRequest(form.value);
        emit('close-modal');
    } catch (error) {
        // The response interceptor surfaces the error toast
    }
};
</script>
<template>
<ModalWrapper @cancel-modal="emit('cancel-modal')">
    <template #header>{{ $t('label.new_request') }}</template>
    <template #subheader>{{ $t('label.create_or_edit', { what: $t('label.request') }) }}</template>

    <form @submit.prevent="save">
        <div class="grid md:grid-cols-2 gap-x-4 gap-y-3">
            <StyledDropdown
                v-model="form.tire_set_hash"
                class="md:col-span-2"
                :options="tireSetOptions"
                name="tire_set_hash"
                :label="$t('label.tire_set')"
                :placeholder="$t('label.tire_set')" />
            <StyledDropdown
                v-model="form.type"
                :options="[
                    { label: $t('label.to_storage'), value: 'to_storage' },
                    { label: $t('label.from_storage'), value: 'from_storage' },
                ]"
                name="type"
                :label="$t('label.type')"
                :placeholder="$t('label.type')" />
            <StyledInput
                v-model="form.scheduled_for"
                name="scheduled_for"
                type="date"
                :placeholder="$t('label.scheduled_for')"
                :label="$t('label.scheduled_for')" />
            <StyledInput
                v-model="form.scheduled_time"
                name="scheduled_time"
                type="time"
                :placeholder="$t('label.scheduled_time')"
                :label="$t('label.scheduled_time')" />
        </div>
    </form>

    <template #footer>
        <StyledSaveButton modal @save="save" />
    </template>
</ModalWrapper>
</template>
